module.exports = __webpack_public_path__ + "img/overview_img_top.512faca2.svg";